import { apiSlice } from './apiSlice';
import type { ScenarioReward } from '../types/inventory';

export const rewardsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getScenarioRewards: builder.query<ScenarioReward[], { saveId: string }>({
      query: ({ saveId }) => ({ url: `/saves/${saveId}/rewards` }),
      transformResponse: (resp: { rewards: ScenarioReward[] }) => resp.rewards ?? [],
      providesTags: (_r, _e, { saveId }) => [{ type: 'SaveV2' as const, id: `rewards-${saveId}` }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetScenarioRewardsQuery } = rewardsApi;
export default rewardsApi;
